module.exports = __webpack_public_path__ + "img/fenxiao.f3ac5710.png";